@if (open()) {
  <section class="ui-dialog-backdrop" (click)="cancelAction.emit()">
    <section class="ui-dialog" [attr.data-tone]="tone()" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <header class="ui-dialog__header">
        <h3>{{ title() | uiLabelTranslate }}</h3>
      </header>

      @if (description()) {
        <p class="ui-dialog__description">{{ description() | uiLabelTranslate }}</p>
      }

      <footer class="ui-dialog__actions">
        <ui-button variant="secondary" (click)="cancelAction.emit()">{{ cancelLabel() | uiLabelTranslate }}</ui-button>
        <ui-button [variant]="tone() === 'danger' ? 'danger' : 'primary'" (click)="confirmAction.emit()">{{ confirmLabel() | uiLabelTranslate }}</ui-button>
      </footer>
    </section>
  </section>
}
